module.exports = __webpack_public_path__ + "static/media/eg6.6d8e6152.webp";